import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { LIVE_PROCESS_STATUS } from 'domains/merchant-product-variant/constants'

const propTypes = {
  liveProcessStatus: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Product Variant `live_process_status`.
 * It maps `live_process_status` to certain style and pass to `StatusBadge`.
 * @param {string} liveProcessStatus
 */
const MerchantProductVariantLiveProcessStatusBadge = ({ liveProcessStatus }) => {

  const colorMap = {
    [LIVE_PROCESS_STATUS.PENDING]    : 'warning',
    [LIVE_PROCESS_STATUS.DISABLED]   : 'danger',
    [LIVE_PROCESS_STATUS.READY_LIVE] : 'primary',
    [LIVE_PROCESS_STATUS.COMPLETED]  : 'success'
  }

  const color = colorMap[liveProcessStatus] || 'default'

  return <StatusBadge color={ color } label={ liveProcessStatus } />
}

MerchantProductVariantLiveProcessStatusBadge.propTypes = propTypes

export default MerchantProductVariantLiveProcessStatusBadge
